<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4" offset-md="4">
        <v-form @submit.prevent="handleLogin">
          <v-text-field
            v-model="user.username"
            label="Username"
            prepend-icon="mdi-account"
          ></v-text-field>
          <v-text-field
            v-model="user.password"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="showPass ? 'text' : 'password'"
            name="input-10-1"
            label="Password"
            hint="At least 8 characters"
            prepend-icon="mdi-key"
            counter
            @click:append="showPass = !showPass"
          ></v-text-field>
          <v-btn
            type="submit"
            class="ma-2"
            block
            :loading="loading"
            :disabled="loading"
            color="primary"
          >
            Login
          </v-btn>
          <v-alert
            dense
            outlined
            type="error"
            v-if="message"
          >
            {{ message }}
          </v-alert>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TradLogin',
  data () {
    return {
      user: {username: '', password: ''},
      showPass: false,
      loading: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
      },
      message: '',
    }
  },
  components: {
  },
  methods: {
    handleLogin() {
      this.loading = true;
      if (this.user.username && this.user.password) {
        this.$store.dispatch('auth/login', this.user).then(
          () => {
            this.$router.push('/home');
          },
          error => {
            this.loading = false;
            this.message = error.response.data.non_field_errors[0]
          }
        );
      }
      else
        this.loading = false;
    }
  }
}
</script>
